import { Theme } from "@mui/material";

export const buttonStyle = (theme: Theme) => ({
  my: 1,
  mx: 1,
  border: 1,
  borderRadius: "5px",
  color: theme.palette.primary.contrastText,
  borderColor: theme.palette.primary.main,
  shadow: 0,
  height: "35.5px",
  width: "150px",
  py: "2px",
  px: "2px",
});

export const labelStyle = {
  fontSize: "13px",
  fontFamily: "IRANSansX",
  px: "15px",
};

export const boldStyle = {
  fontFamily: "IRANSansXBold",
  fontSize: "15px",
};

export const iconSize = {
  fontSize: "20px",
};

export const inputBoxStyle = (theme: Theme) => ({
  border: "1px",
  borderColor: theme.customColors.neutral[80],
  borderRadius: "12px",
  background: theme.customColors.neutral.surfaceContainerLowest,
  color: theme.palette.text.secondary,
  height: "48px",
  padding: "10px",
  paddingTop: "5px",
  paddingBottom: "5px",
  fontSize: "12px ",
  fontFamily: "IRANSansX",
  overflow: "visible",
});

export const inputBoxPositions = {
  borderRadius: "16px",
  marginBottom: "20px",
  marginRight: "12px",
  fontFamily: "IRANSansX",
};
export const selectBoxPositions = {
  borderRadius: "16px",
  marginBottom: "18px",
  marginRight: "12px",
  fontFamily: "IRANSansX",
};
// inputPropsConfig.ts or wherever appropriate
export const customInputProps = (theme: Theme) => ({
  customStyle: {
    ...inputBoxPositions,
  },
  type: "text",
  RichTextArea: 1,
  customLabelPosition: { alignSelf: "start" },
  textStyle: {
    fontSize: "16px",
    marginBottom: "4px",
    fontFamily: "IRANSansX",
  },
  boxStyle: {
    ...inputBoxStyle(theme),
  },
  autoFocus: false,
  handleBlur: true,
  disabled: false,
});

export const customCaptchaProps = (theme: Theme) => ({
  type: "text",
  RichTextArea: 1,
  customLabelPosition: { alignSelf: "start" },
  textStyle: {
    fontSize: "16px",
    marginBottom: "8px",
    marginRight: "0px",
    marginLeft: "0px",
    fontFamily: "IRANSansX",
  },
  boxStyle: {
    ...inputBoxStyle(theme),
    marginLeft: "0px",
    marginRight: "0px",
  },
  autoFocus: true,
  handleBlur: true,
  disabled: false,
});

export const customLinkProps = (theme: Theme) => ({
  isUnderline: true,
  customStyle: {
    color: theme.customColors.neutral[10],
    fontFamily: "IRANSansX",
    fontSize: "14px",
  },
});
export const customSelectProps = (theme: Theme) => ({
  customStyle: {
    ...selectBoxPositions,
  },
  textStyle: {
    fontSize: "16px",
    marginBottom: "8px",
    marginLeft: "8px",
    fontFamily: "IRANSansX",
  },
  boxStyle: {
    ...inputBoxStyle(theme),
  },
  optionsStyle: {
    fontSize: "16px",
    marginBottom: "8px",
    fontFamily: "IRANSansX",
  },
});

export const typographyStyle = (theme: Theme) => ({
  fontFamily: "IRANSansX",
  fontSize: "12px",
  borderRadius: "12px",
  background: theme.customColors.neutral[98],
  maxWidth: "92%",
  color: theme.customColors.neutral[50],
  padding: "10px",
  height: "28px",
});
